import { ViewEditNarrativeFuturePEMultipleCalculator } from './ViewEditNarrativeFuturePEMultipleCalculator';
import type { Valuation } from '../../hooks/valuationFragment';
import {
  getCappedSmallCapSharesOutstandingGrowthRate,
  isValidRangeOfSmallCapSharesOutstandingGrowthRate,
} from './sharesOutstanding';
import { calculateSharesOutstandingGrowthRate } from './sharesOutstanding';

export class SmallCapFuturePEMultipleCalculator extends ViewEditNarrativeFuturePEMultipleCalculator {
  constructor(valuation: Valuation) {
    super(valuation);

    const currentSharesOutstandingGrowthRate =
      this._presentSharesOutstanding !== 0 &&
      this._previousYearSharesOutstanding !== 0
        ? calculateSharesOutstandingGrowthRate({
            sharesOutstanding: this._presentSharesOutstanding,
            previousYearSharesOutstanding: this._previousYearSharesOutstanding,
          })
        : 0;

    // For small cap companies, we always use the current growth rate without standard deviation check
    this._sharesOutstandingGrowthRate =
      isValidRangeOfSmallCapSharesOutstandingGrowthRate(
        currentSharesOutstandingGrowthRate
      )
        ? currentSharesOutstandingGrowthRate
        : getCappedSmallCapSharesOutstandingGrowthRate(
            currentSharesOutstandingGrowthRate
          );
  }
}
